
import { Button, Checkbox, Form, Icon, Input, Modal, Popover } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import iconStyle from '../components/icon.cs';
import { cancelEdit, deleteUser, editAttr, save, inactivateUser, activateUser, resetPassword } from './userActions';
import { formItemLayout, getRequiredRule, getDateRule } from '../utils/antUtils';

const FormItem = Form.Item;

class UserModalComponent extends Component {

  state = {
    confirmDeleteVisible: false
  }

  handleSubmit = (e) => {

    this.props.form.validateFields((errors) => {
      if (errors) {
        return false;
      }

      let form = this.props.form.getFieldsValue();

      this.props.dispatch(save(this.props.edit, this.props.orgId, form.expiryDate))
    });
  }

  handleCancel = (e) => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(cancelEdit());
  }

  deleteConfirmed = () => {
    this.setState({ confirmDeleteVisible: false });
    this.props.dispatch(deleteUser(this.props.edit.id, this.props.orgId));
  }

  toggleActivate = () => {
    if (this.props.edit.enabled) {
      this.props.dispatch(inactivateUser(this.props.edit.id, this.props.orgId));
    }
    else {
      this.props.dispatch(activateUser(this.props.edit.id, this.props.orgId));
    }
  }

  resetPassword = () => {
    this.props.dispatch(resetPassword(this.props.edit.id, this.props.orgId));
  }

  onChange(event, attr) {
    this.props.dispatch(editAttr(attr, event.target.value));
  }

  onChangeCheckbox(value, attr) {
    this.props.dispatch(editAttr(attr, value));
  }

  render() {

    if (!this.props.edit) {
      return null;
    }


    const tailFormItemLayout = {
      wrapperCol: { xs: { span: 24, offset: 0, }, sm: { span: 16, offset: 8, } }
    };

    const { getFieldDecorator } = this.props.form;

    let confirmPopup = (<div>
      <Button onClick={this.deleteConfirmed}>Ja</Button>
      <Button style={{ marginLeft: 10 }} onClick={() => this.setState({ confirmDeleteVisible: false })}>Nej</Button>
    </div>);

    let footer = this.props.edit.id === -1 ? [] : [<div style={{ float: 'left' }}>
      <Popover visible={this.state.confirmDeleteVisible} placement="topLeft" title={'Är du säker?'} content={confirmPopup} trigger="click">
        <Button type="danger" onClick={() => this.setState({ confirmDeleteVisible: true })} >Radera användare</Button>
      </Popover>
      <Button onClick={this.toggleActivate} >{this.props.edit.enabled ? 'Inaktivera användare' : 'Aktivera användare'}</Button>
      <Button onClick={this.resetPassword} >Återställ lösenord</Button>
    </div>];

    footer.push(<Button key="back" onClick={this.handleCancel}>Avbryt</Button>);
    footer.push(<Button key="submit" type="primary" onClick={this.handleSubmit}>Spara</Button>);

    let isAdd = this.props.edit.id === -1;

    return (

      <Modal
        title={this.props.edit && isAdd ?
          'Ny användare' :
          <Icon type='user' style={iconStyle} />}
        visible={!!this.props.edit}
        onCancel={this.handleCancel}
        maskClosable={false}
        footer={footer}
        width={800}
      >
        <div>
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout} label="E-post" >
              {getFieldDecorator('email', { rules: [{ required: true, message: 'Ange en e-post' }], })(
                <Input autoFocus onBlur={(e) => this.onChange(e, 'email')} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Förnamn" >
              {getFieldDecorator('firstName', { rules: [{ required: true, message: 'Ange ett förnamn' }], })(
                <Input onBlur={(e) => this.onChange(e, 'firstName')} />)}
            </FormItem>
            <FormItem {...formItemLayout} label="Efternamn" >
              {getFieldDecorator('lastName', { rules: [{ required: true, message: 'Ange ett efternamn' }], })(
                <Input onBlur={(e) => this.onChange(e, 'lastName')} />)}
            </FormItem>


            <FormItem {...tailFormItemLayout}>
              {getFieldDecorator('admin', {
                valuePropName: 'checked'
              })(
                <Checkbox onChange={(e) => this.onChangeCheckbox(e.target.checked, 'admin')}>Kund Admin (kan skapa egna användare under företaget)</Checkbox>                
              )}
            </FormItem>

            <FormItem {...tailFormItemLayout}>
              {getFieldDecorator('featureSbtPlus', {
                valuePropName: 'checked'
              })(
                <Checkbox onChange={(e) => this.onChangeCheckbox(e.target.checked, 'featureSbtPlus')}>Rättsfall plus</Checkbox>                
              )}
            </FormItem>

            {
              isAdd ? null : <FormItem {...formItemLayout} label="Utgångsdatum" >
                {getFieldDecorator('expiryDate', { rules: [getRequiredRule('Ange ett utgångsdatum'), getDateRule('Ange ett giltigt utgångsdatum på formatet: 2017-12-24')], })(
                  <Input />
                )}
              </FormItem>
            }

          </Form>

        </div>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    orgId: state.user.orgId,
    edit: state.user.edit
  }
};


export default connect(mapStateToProps)(Form.create({
  mapPropsToFields(props) {

    return {
      email: Form.createFormField({ value: props.edit ? props.edit.email : '' }),
      firstName: Form.createFormField({ value: props.edit ? props.edit.firstName : '' }),
      lastName: Form.createFormField({ value: props.edit ? props.edit.lastName : '' }),
      password: Form.createFormField({ value: props.edit ? props.edit.password : '' }),
      expiryDate: Form.createFormField({ value: props.edit ? props.edit.expiryDate : '' }),
      admin: Form.createFormField({ value: props.edit ? props.edit.admin : false }),
      featureSbtPlus: Form.createFormField({ value: props.edit ? props.edit.featureSbtPlus : false })
    }
  }
})(UserModalComponent));



// WEBPACK FOOTER //
// ./src/user/userModalComponent.js